const PlanCard = ({ title, type, data, expiry, operator, onRenew, onChange, onDevices, onStelfiberDevices, onDelete, loading, 
  cooldownActive, remainingTime, disableActions, showAddUser, onAddUser, addUserLoading, preserveTime }) => {
  if (!data) {
    return (
      <div className="plan-card empty">
        <h4>{title}</h4>
        <p>No plan selected</p>
        <button onClick={onChange}>Select Plan</button>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="plan-card12 loading-card12">
        <div className="spinner12"></div>
        <p>Processing...</p>
      </div>
    );
  }

  const isActivePlan = (expiry) => {
    if (!expiry) return false;

    const exp = new Date(expiry);

    // Some providers (e.g. Pioneer IPTV) expire mid-day rather than at
    // midnight, so their expiry needs to be compared as a full datetime
    // instead of truncating both sides down to just the date.
    if (preserveTime) {
      return exp >= new Date();
    }

    const today = new Date();

    // remove time
    today.setHours(0,0,0,0);
    exp.setHours(0,0,0,0);

    return exp >= today;
  };

  const isActive = isActivePlan(expiry);

  return (
    <div className={`plan-card ${isActive ? "active-plan" : "expired-plan"}`}>
      
      {/* HEADER */}
      <div className="plan-header">
        <h3 className="plan-title">{data.planName}</h3>
        <span className="plan-price">
          ₹ {operator ? data.planPrice + operator.packPrice : data.planPrice}
        </span>
      </div>

      {/* EXPIRY (placeholder for now) */}
      <div className="plan-expiry">
        <p className="cust-expiry">Expiry Date:  {expiry? expiry : "--"}</p> {/* later replace with API */}
      </div>

      {/* OTT APPS */}
      <div className="ott-grid-cust">
        {data.ott?.map((app) => {
            const lowerOtt = app.toLowerCase();

            return (
            <div key={app} className="ott-item-cust">
                <img
                src={`https://vrplay.in/images/${lowerOtt}.png`}
                alt={app}
                onError={(e) => {
                    e.target.src = "https://vrplay.in/images/default.png";
                }}
                />
                <p>{app}</p>
            </div>
            );
        })}
      </div>

      {/* NOT REGISTERED WITH PROVIDER YET */}
      {showAddUser && (
        <div className="plan-not-registered-note">
          <p>⚠️ Customer isn't registered with {title} yet. Add them before recharging.</p>
        </div>
      )}

      {/* ACTION */}
      {(!disableActions && type !== "playboxtv") && (
        <div className="plan-actions">
          {showAddUser ? (
            <button
              className="btn-add-provider-user"
              onClick={onAddUser}
              disabled={addUserLoading}
            >
              {addUserLoading ? "Adding..." : "➕ Add User"}
            </button>
          ) : (
            <>
              <button
                onClick={onRenew}
                disabled={
                  loading ||
                  cooldownActive ||
                  (isActive && !cooldownActive && (type === "watcho" || type === "playboxtv" || 
                    type === "pioneeriptv" || type === "antiptv" || type === "etvwin" )) // disable renew for active watcho/playboxtv plans
                }
              >
                {cooldownActive
                  ? `Recharge ${remainingTime}`
                  : (type === "watcho" || type === "playboxtv" || type === "pioneeriptv" || 
                    type === "antiptv" || type === "etvwin") && isActive
                  ? "Advance Renewal (Coming Soon)"
                  : isActive
                  ? "Advance Renewal"
                  : "Recharge"}
              </button>
              <button
                onClick={onChange}
                disabled={isActive}
              >
                Change Plan
              </button>
            </>
          )}
          {type === "sitiplay" && (
            <>
              <button onClick={onDevices}>Devices</button>
              <button onClick={onStelfiberDevices}>Stelfiber Devices</button>
            </>
          )}
          {onDelete && (
              <button className="btn-delete1" onClick={onDelete} disabled={isActive}>
                  🗑 Remove
              </button>
          )}
        </div>
      )}

    </div>
  );
};

export default PlanCard;